import type { DeleteCausesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (count: number): DeleteCausesMutation => {
  return {
    delete_cause: {
      __typename: 'cause_mutation_response',
      affected_rows: count,
    },
  };
};

export const useDeleteCausesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.cause.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.cause.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.cause.getById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.cause.getByParentIssueId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteCauses: async (variables: {
      Ids: string[];
    }): Promise<DeleteCausesMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result.deletedCount);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
